import React, { useContext } from "react";
import { Platform, SafeAreaView } from "react-native";
import {
  Box,
  OldButton as Button,
  Typography,
  Stack,
  Divider,
} from "digiwash-components";
import { useSelector } from "react-redux";
import userSelectors from "../../ducks/user/selectors";
import { LoginContext } from "../../contexts/login";
import useNavigation from "../../hooks/useNavigation";
import useRoute from "../../hooks/useRoute";
import { iosSafeArePadding } from "../../helpers/general";
import CustomIcon from "../CustomIcon";

let nativeStyles = {
  container: {
    backgroundColor: "#fff",
  },
  bar: {
    backgroundColor: "#fff",
    borderTopWidth: 1,
    borderColor: "#ccc",
  },
};

let webStyles = {
  container: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    zIndex: 11,
  },
  bar: {
    backgroundColor: "#fff",
    maxWidth: 768,
    margin: "auto",
    width: "100%",
    border: "1px solid #ccc",
    borderBottom: "",
    borderTopRightRadius: "12px",
    borderTopLeftRadius: "12px",
    paddingBottom: iosSafeArePadding(),
  },
};
let overrideStyles = Platform.OS === "web" ? webStyles : nativeStyles;
let styles = {
  ...overrideStyles,
};

const ROUTES = [
  {
    key: "Home",
    icon: "homeDefault",
    activeIcon: "homeActive",
    title: "خانه",
  },
  {
    key: "Orders",
    icon: "ordersDefault",
    activeIcon: "ordersActive",
    title: "سفارش ها",
    protected: true,
  },
  {
    key: "Profile",
    icon: "profileDefault",
    activeIcon: "profileActive",
    title: "پروفایل",
    protected: true,
  },
];

let Container = Platform.OS === "web" ? Box : SafeAreaView;

function BottomNavigation(props) {
  let nav = useNavigation();
  let routeInfo = useRoute();
  let authenticated: boolean = useSelector(userSelectors.getToken);
  let { setLoginModalOpen } = useContext(LoginContext);

  return (
    <Container style={styles.container}>
      <Stack style={styles.bar} distribution="space-around">
        {ROUTES.map((route, idx) => {
          const isFocused = routeInfo.name == route.key;
          return (
            <Button
              key={idx}
              accessibilityRole="button"
              accessibilityState={isFocused ? { selected: true } : {}}
              onPress={() => {
                if (!isFocused) {
                  if (route.protected && !authenticated) {
                    setLoginModalOpen(true);
                    return;
                  }

                  nav.navigate(route.key);
                }
              }}
              style={{ flex: 1, padding: 5 }}
            >
              <Stack direction="vertical">
                <CustomIcon
                  icon={isFocused ? route.activeIcon : route.icon}
                  width={24}
                  height={24}
                />
                <Divider size="s" />
                <Typography fs="s" color="primary.main">
                  {route.title}
                </Typography>
              </Stack>
            </Button>
          );
        })}
      </Stack>
    </Container>
  );
}

export default BottomNavigation;
